// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Link = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.598 4.786A.75.75 0 0 0 9.696 5.81h.001l3.359-3.36a3.227 3.227 0 0 1 4.596 0 3.226 3.226 0 0 1 0 4.597l-3.712 3.712a3.227 3.227 0 0 1-4.596 0 .75.75 0 1 0-1.075 1.047l.014.014a4.756 4.756 0 0 0 6.717 0l3.713-3.713a4.756 4.756 0 0 0 0-6.717 4.756 4.756 0 0 0-6.718 0L8.637 4.747a.81.81 0 0 0-.04.04Zm-7.21 7.21a4.756 4.756 0 0 0 0 6.717 4.756 4.756 0 0 0 6.718 0l3.36-3.36a.75.75 0 1 0-1.047-1.074l-.015.014-3.358 3.36a3.226 3.226 0 0 1-4.597 0 3.226 3.226 0 0 1 0-4.597l3.713-3.712a3.227 3.227 0 0 1 4.596 0 .75.75 0 0 0 1.075-1.046l-.014-.015a4.756 4.756 0 0 0-6.718 0L1.39 11.995Z"
			fill="#4A90E2"
		/>
	</svg>
);
export default Link;
